import { Line, mixins } from 'vue-chartjs'

export default {
  extends: Line,
  // This mixin takes care of re-rendering chart when props change
  mixins: [mixins.reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    chartDataChanged: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    chartDataChanged() {
      this.$data._chart.options = this.options
      this.$data._chart.update()
    },
  },
  mounted() {
    // Hacky way to add margin between legend and chart
    // ref https://stackoverflow.com/questions/42585861/chart-js-increase-spacing-between-legend-and-chart
    this.addPlugin({
      beforeInit: function(chart) {
        chart.legend.afterFit = function() {
          this.height += 20 // must use `function` and not => because of `this`
        }
      },
    })

    this.renderChart(this.chartData, this.options)
  },
}
